import e from "react";
import { FederatedIdentityProviders as o, translate as t } from "@aws-amplify/ui";
import { Divider as r } from "../../../primitives/Divider/Divider.js";
import { Flex as i } from "../../../primitives/Flex/Flex.js";
import { useAuthenticator as n } from "@aws-amplify/ui-react-core";
import { FederatedSignInButton as a } from "./FederatedSignInButtons/FederatedSignInButton.js";
function s() {
  var _n = n(function (_ref) {
      var e = _ref.route,
        o = _ref.socialProviders;
      return [e, o];
    }),
    s = _n.route,
    c = _n.socialProviders;
  if (0 === c.length) return null;
  var l = "signUp" === s ? "Up" : "In";
  return e.createElement(i, {
    direction: "column",
    padding: "0 0 1rem 0",
    className: "federated-sign-in-container"
  }, c.map(function (r) {
    switch (r) {
      case "amazon":
        return e.createElement(a, {
          icon: "amazon",
          key: r,
          provider: o.Amazon,
          text: t("Sign ".concat(l, " with Amazon"))
        });
      case "apple":
        return e.createElement(a, {
          icon: "apple",
          key: r,
          provider: o.Apple,
          text: t("Sign ".concat(l, " with Apple"))
        });
      case "facebook":
        return e.createElement(a, {
          icon: "facebook",
          key: r,
          provider: o.Facebook,
          text: t("Sign ".concat(l, " with Facebook"))
        });
      case "google":
        return e.createElement(a, {
          icon: "google",
          key: r,
          provider: o.Google,
          text: t("Sign ".concat(l, " with Google"))
        });
      default:
        console.error("Authenticator does not support ".concat(r, ". Please open an issue: https://github.com/aws-amplify/amplify-ui/issues/choose"));
    }
  }), e.createElement(r, {
    size: "small",
    label: "or"
  }));
}
export { s as FederatedSignIn };